import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../Components/Sidebar/Sidebar";
import MobileAppNav from "../Components/MobileAppNav/MobileAppNav";
import Header from "../Header/Header";
import "./AdminLayout.scss";

export default function AdminLayout({ children }) {
  const location = useLocation();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  useEffect(() => {
    if (!mobileNavOpen) return;
    const mq = window.matchMedia("(max-width: 1100px)");
    if (!mq.matches) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [mobileNavOpen]);

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 1101px)");
    const onChange = () => {
      if (mq.matches) setMobileNavOpen(false);
    };
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  useEffect(() => {
    if (!mobileNavOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") setMobileNavOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [mobileNavOpen]);

  return (
    <div className="containe_r">
      <div className="admin_layout">
        <Sidebar
          mobileOpen={mobileNavOpen}
          onMobileClose={() => setMobileNavOpen(false)}
        />

        <div className="main_section">
          <Header onMenuClick={() => setMobileNavOpen(true)} />
          <div className="page_content page_content--app-shell" key={location.pathname}>
            {children}
          </div>
        </div>
      </div>
      <MobileAppNav onOpenMenu={() => setMobileNavOpen(true)} />
    </div>
  );
}
